import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../global/global.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerRequestsService {
  constructor(private http: HttpClient, private globalService: GlobalService) {}

  getToken4OldWeb(CUC) {
    return this.http.get(`${this.globalService.globalEnvironments.apiEndpoint.apiClientes}/generarToken/${CUC}`).pipe();
  }
}
